import dataService from '../../data/data.service';
import _ from 'lodash';

const state = {
  ageGroups: []
}

const getters = {
  ageGroups: (state) => {
    return state.ageGroups
  }
}

const actions = {
  get(context) {
    return new Promise(resolve => {
      dataService.modules.ageGroup.get().then(data => {
        context.commit('get', data);
        resolve();
      });
    });
  },
}

const mutations = {
  get(state, data) {
    state.ageGroups = data.filter(age => age.status === "ACTIVE");
    state.ageGroups = _.orderBy(state.ageGroups, ['ageGroup', 'asc']);
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}